<template>
  <div class="three-d-dropdown">
    <FloatingMenu v-show="isLayerMenuShowing" class="three-d-dropdown-list" arrow-position="bottom">
      <div class="list-wrapper text-gray-900 py-6">
        <slot />
      </div>
    </FloatingMenu>
    <DeckControlsContainer>
      <DeckControlButton :is-active="isLayerMenuShowing" @click="$emit('toggle')">
        <LayerIcon />
      </DeckControlButton>
    </DeckControlsContainer>
  </div>
</template>

<script lang="ts" setup>
import LayerIcon from '@/components/three-d/LayerIcon.svg'

defineProps({
  isLayerMenuShowing: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['toggle'])
</script>

<style lang="stylus">
.three-d-dropdown
  position relative

  &-list
    --arrowRight 1.875rem

    bottom 6rem
    right -1rem
    border none
    position absolute
    text-align left
    background-color transparent
    margin 0

    .list-wrapper
      max-height 400px
      max-height @css {max(150px, min(400px, calc(100vh - 340px)))}
      overflow-y scroll

    .dropdown-item
      &:hover, &:focus
        @apply text-gray-600
        background-color transparent

      &-title, &-indicator
        display inline-block
        vertical-align middle

      &-indicator
        width 16px
        height 16px
        border-radius 50%
        margin-right 10px
        text-align center
        line-height 32px

  .control-button
    padding 10px
</style>
